import * as React from "react";

import { ActionCode } from "./api";
import { ERoutes } from "./AppRouter";
import {
  INavigationItem,
  SessionAwaitingValidationCounter,
} from "./components";
import { ETLCodes } from "./locales/ETLCodes";

export const BaseAppNavigation: INavigationItem[] = [
  {
    name: ETLCodes.Home,
    icon: "home",
    route: ERoutes.home,
  },
  {
    name: ETLCodes.Trainings,
    icon: "highlight",
    actions: [ActionCode.ViewTrainings],
    items: [
      {
        name: ETLCodes.Trainings,
        icon: "office",
        route: ERoutes.trainings,
        actions: [ActionCode.ViewTrainings],
      },
    ],
  },
  {
    name: ETLCodes.Planning,
    icon: "calendar",
    actions: [ActionCode.ViewTrainings, ActionCode.ViewRoomPlanning],
    items: [
      {
        name: ETLCodes.Protime,
        icon: "document",
        route: ERoutes.protimePlanning,
        actions: [ActionCode.ViewTrainings],
      },
      {
        name: ETLCodes.Employees,
        icon: "people",
        route: ERoutes.employeePlanning,
        actions: [ActionCode.ViewTrainings],
      },
      {
        name: ETLCodes.Rooms,
        icon: "office",
        route: ERoutes.roomPlanning,
        actions: [ActionCode.ViewRoomPlanning],
      },
    ],
  },
  {
    name: ETLCodes.Contacts,
    icon: "people",
    actions: [
      ActionCode.ViewEmployees,
      ActionCode.ViewNewComers,
      ActionCode.ViewPartners,
      ActionCode.EditNewComer,
    ],
    items: [
      {
        name: ETLCodes.Employees,
        icon: "people",
        route: ERoutes.employees,
        actions: [ActionCode.ViewEmployees],
      },
      {
        route: ERoutes.newComers,
        name: ETLCodes.Newcomers,
        icon: "route",
        actions: [ActionCode.ViewNewComers, ActionCode.EditNewComer],
      },
      {
        name: ETLCodes.Partners,
        icon: "person",
        route: ERoutes.partners,
        actions: [ActionCode.ViewPartners],
      },
    ],
  },
  {
    name: ETLCodes.Tasks,
    icon: "endorsed",
    actions: [
      ActionCode.ViewAttendance,
      ActionCode.ViewMeeting,
      ActionCode.ViewDuties,
    ],
    items: [
      {
        name: ETLCodes.Dashboard,
        icon: "calendar",
        route: ERoutes.dashboard,
        //actions: [ActionCode.ViewAttendance],
      },
      {
        name: ETLCodes.Duties,
        icon: "confirm",
        route: ERoutes.duties,
        actions: [ActionCode.ViewDuties],
      },
      {
        name: ETLCodes.Attendance,
        icon: "hand",
        route: ERoutes.attendance,
        actions: [ActionCode.ViewAttendance],
        rightElement: <SessionAwaitingValidationCounter />,
      },
      {
        name: ETLCodes.Appointments,
        icon: "confirm",
        route: ERoutes.meeting,
        actions: [ActionCode.ViewMeeting],
      },
      // {
      //   name: ETLCodes.ReminderPhoneCalls,
      //   icon: "phone",
      //   route: ERoutes.reminderPhoneCalls,
      //   //actions: [ActionCode.ViewAttendance],
      // },
    ],
  },
  {
    name: ETLCodes.Administration,
    icon: "cog",
    actions: [
      ActionCode.ViewUsers,
      ActionCode.ViewSites,
      ActionCode.ViewRooms,
      ActionCode.ViewTrainingTypes,
      ActionCode.ViewMailTemplates,
      ActionCode.ViewSmsTemplates,
      ActionCode.EditTranslation,
      ActionCode.ViewPartnerTypes,
      ActionCode.ViewThematicTypes,
    ],
    items: [
      {
        name: ETLCodes.Users,
        icon: "user",
        route: ERoutes.users,
        actions: [ActionCode.ViewUsers],
      },
      {
        name: ETLCodes.PartnerTypes,
        icon: "heat-grid",
        route: ERoutes.partnerTypes,
        actions: [ActionCode.ViewPartnerTypes],
      },
      {
        name: ETLCodes.ThematicTypes,
        icon: "heat-grid",
        route: ERoutes.thematicTypes,
        actions: [ActionCode.ViewThematicTypes],
      },
      {
        name: ETLCodes.MeetingTypes,
        icon: "people",
        route: ERoutes.meetingTypes,
        actions: [ActionCode.ViewMeetingType],
      },
      {
        name: ETLCodes.HourlyTypes,
        icon: "time",
        route: ERoutes.hourlyTypes,
        actions: [ActionCode.ViewHourlyType],
      },
      {
        name: ETLCodes.Assignments,
        icon: "tag",
        route: ERoutes.assignments,
        actions: [ActionCode.ViewAssignment],
      },
      {
        name: ETLCodes.Sites,
        icon: "office",
        route: ERoutes.sites,
        actions: [ActionCode.ViewSites],
      },

      {
        name: ETLCodes.Rooms,
        icon: "square",
        route: ERoutes.rooms,
        actions: [ActionCode.ViewRooms],
      },
      {
        name: ETLCodes.TrainingTypes,
        icon: "heat-grid",
        route: ERoutes.trainingTypes,
        actions: [ActionCode.ViewTrainingTypes],
      },
      {
        name: ETLCodes.SmsTemplates,
        icon: "sim-card",
        route: ERoutes.smsTemplates,
        actions: [ActionCode.ViewSmsTemplates],
      },
      {
        name: ETLCodes.RoleAndRights,
        icon: "person",
        route: ERoutes.userRoles,
        actions: [ActionCode.ViewRoles],
      },
      {
        name: ETLCodes.Translations,
        icon: "text-highlight",
        route: ERoutes.translations,
        actions: [ActionCode.EditTranslation],
      },
      {
        name: ETLCodes.DataTranslations,
        icon: "data-connection",
        route: ERoutes.dataTranslations,
        actions: [ActionCode.EditTranslation],
      },
    ],
  },
];

const InnerFindAppNavigationItemFromRoute = (
  pathname: string,
  navItem: INavigationItem
): INavigationItem | null => {
  if (navItem && navItem.route && pathname.startsWith(navItem.route)) {
    return navItem;
  }
  const nextNavItems = navItem.items;
  if (nextNavItems && nextNavItems?.length > 0) {
    for (const i of nextNavItems) {
      const found = InnerFindAppNavigationItemFromRoute(pathname, i);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const FindAppNavigationItemFromRoute = (pathname: string) => {
  for (const i of BaseAppNavigation) {
    const found = InnerFindAppNavigationItemFromRoute(pathname, i);
    if (found) return found;
  }
  return null;
};
